import { DomainNameErrors } from '@wix/domains-serverless-interface';
export const DomainActionEnum = {
  connect: 'connect',
  assign: 'assign',
  purchase: 'purchase',
  transfer: 'transfer',
  upgradePaywall: 'upgradePaywall',
  upgradePaywallModal: 'upgradePaywallModal',
  upgrade: 'upgrade',
  redirectToSitePage: 'redirectToSitePage',
  redirectToEditorSitePage: 'redirectToEditorSitePage',
  redirectToDashboardPage: 'redirectToDashboardPage',
  redirectToUpgradeSplitPage: 'redirectToUpgradeSplitPage'
};
export const DomainSearchError = {
  TECHNICAL_ERROR: 'TECHNICAL_ERROR',
  NO_STATUS: 'noStatus',
  // Assign errors
  ALREADY_ASSIGNED: 'alreadyAssigned',
  ALREADY_ASSIGNED_TO_THIS_SITE: 'alreadyAssignedToThisSite',
  FLOATING_DOMAIN: 'floatingDomain',
  LANGUAGE_CODE_SUBDOMAIN: 'languageCodeSubdomain',
  CANNOT_ASSIGN_TO_SHARED_SITE: 'cannotAssignToSharedSite',
  EXTERNAL_VIEWER_POINTING_DOMAIN: 'externalViewerPointingDomain',
  EXTERNAL_VIEWER_ASSIGN_SUBDOMAIN_NOT_ALLOWED: 'externalViewerAssignSubdomainNotAllowed',
  UPGRADE_REQUIRE_ASSIGN: 'upgradeRequireAssign',
  // Purchase errors
  NOT_SUPPORTED_TLD: 'notSupportedTld',
  NOT_SUPPORTED_TLD_REGIONAL: 'notSupportedTldRegional',
  NO_PERMISSIONS_TO_PURCHASE: 'noPermissionsToPurchase',
  EXTERNAL_VIEWER_PURCHASE_SUBDOMAIN_NOT_ALLOWED: 'externalViewerPurchaseSubdomainNotAllowed',
  PURCHASE_ROOT_DOMAIN_IS_REQUIRED: 'purchaseRootDomainIsRequired',
  UPGRADE_REQUIRE_PURCHASE: 'upgradeRequirePurchase',
  UPGRADE_REQUIRE_PURCHASE_SUBDOMAIN: 'upgradeRequirePurchaseSubdomain',
  // Transfer in errors
  TRANSFER_IN_LOCKED_BY_PROVIDER: 'lockedByProvider',
  UPGRADE_REQUIRE_TRANSFER_IN: 'upgradeRequireTransferIn',
  // Connect errors
  SUBDOMAIN_ROOT_IS_NOT_CONNECTED: 'subdomainRootIsNotConnected',
  ROOT_DOMAIN_IS_CONNECTED_BY_POINTING: 'rootDomainIsConnectedByPointing',
  SUBDOMAIN_ROOT_IS_CONNECTED_BY_DNS: 'subdomainRootIsConnectedByDns',
  DOMAIN_TAKEN_IN_WIX: 'domainTakenInWix',
  SUBDOMAIN_TAKEN_IN_WIX: 'subdomainTakenInWix',
  EXTERNAL_VIEWER_CONNECT_SUBDOMAIN_NOT_ALLOWED: 'externalViewerConnectSubdomainNotAllowed',
  UNAUTHORIZED: 'unauthorized',
  SUBDOMAIN_ROOT_IS_REGISTERED: 'subdomainRootIsRegistered',
  NO_PERMISSIONS_TO_CONNECT: 'noPermissionsToConnect',
  UPGRADE_REQUIRE_CONNECT: 'upgradeRequireConnect',
  // Business email errors
  GOOGLE_CUSTOMER_EXISTS: 'googleCustomerExists',
  GOOGLE_RESTRICTED_WORD: 'googleRestrictedWord'
};
export const DomainActionsErrorsMap = {
  [DomainActionEnum.connect]: [DomainSearchError.NO_PERMISSIONS_TO_CONNECT, DomainSearchError.LANGUAGE_CODE_SUBDOMAIN, DomainSearchError.SUBDOMAIN_ROOT_IS_NOT_CONNECTED, DomainSearchError.ROOT_DOMAIN_IS_CONNECTED_BY_POINTING, DomainSearchError.SUBDOMAIN_ROOT_IS_CONNECTED_BY_DNS, DomainSearchError.SUBDOMAIN_ROOT_IS_REGISTERED, DomainSearchError.DOMAIN_TAKEN_IN_WIX, DomainSearchError.SUBDOMAIN_TAKEN_IN_WIX, DomainSearchError.UPGRADE_REQUIRE_CONNECT, DomainSearchError.ALREADY_ASSIGNED, DomainSearchError.EXTERNAL_VIEWER_CONNECT_SUBDOMAIN_NOT_ALLOWED, DomainSearchError.UPGRADE_REQUIRE_ASSIGN],
  [DomainActionEnum.assign]: [DomainSearchError.EXTERNAL_VIEWER_POINTING_DOMAIN, DomainSearchError.FLOATING_DOMAIN, DomainSearchError.ALREADY_ASSIGNED, DomainSearchError.ALREADY_ASSIGNED_TO_THIS_SITE, DomainSearchError.CANNOT_ASSIGN_TO_SHARED_SITE, DomainSearchError.LANGUAGE_CODE_SUBDOMAIN, DomainSearchError.EXTERNAL_VIEWER_ASSIGN_SUBDOMAIN_NOT_ALLOWED, DomainSearchError.UPGRADE_REQUIRE_ASSIGN],
  [DomainActionEnum.purchase]: [DomainSearchError.NO_PERMISSIONS_TO_PURCHASE, DomainSearchError.PURCHASE_ROOT_DOMAIN_IS_REQUIRED, DomainSearchError.EXTERNAL_VIEWER_PURCHASE_SUBDOMAIN_NOT_ALLOWED, DomainSearchError.UPGRADE_REQUIRE_PURCHASE, DomainSearchError.NOT_SUPPORTED_TLD, DomainSearchError.UPGRADE_REQUIRE_PURCHASE_SUBDOMAIN, DomainSearchError.NOT_SUPPORTED_TLD_REGIONAL],
  [DomainActionEnum.transfer]: [DomainSearchError.NO_PERMISSIONS_TO_PURCHASE, DomainSearchError.TRANSFER_IN_LOCKED_BY_PROVIDER, DomainSearchError.SUBDOMAIN_ROOT_IS_NOT_CONNECTED, DomainSearchError.UPGRADE_REQUIRE_TRANSFER_IN]
};
export const EnforcementRule = {
  ALWAYS: 'always',
  NEVER: 'never',
  CONDITIONAL: 'conditional'
};
const ActionEnforcementRule = [EnforcementRule.ALWAYS, EnforcementRule.NEVER];

/**
 * Action configuration mapping - defines priority, dependencies, and error rules
 * autoInvoke: true: the action will be invoked instantly
 * false: the action will not be invoked instantly
 */

export const AllStatuses = [...Object.values(DomainSearchError), ...Object.values(DomainNameErrors), ...Object.values(DomainActionEnum)];
//# sourceMappingURL=types.js.map